import { useState, FormEvent } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('name', formData.name);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('service', formData.service);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d5hvk5jgekujqjrtsr9g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', phone: '', service: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-32 px-8 lg:px-16 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-20">
          <div className="w-20 h-px bg-black mb-8 mx-auto"></div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-black mb-8 leading-tight">
            Expertise you can trust.<br />Representation without compromise.
          </h2>
          <p className="text-lg md:text-xl text-gray-700">
            Speak with SYG Yachts
          </p>
        </div>

        <form id="syg-contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-8">
          <div>
            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              required
              className="w-full px-0 py-4 border-0 border-b-2 border-gray-300 focus:border-black focus:outline-none text-lg bg-transparent transition-colors"
            />
          </div>

          <div>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              className="w-full px-0 py-4 border-0 border-b-2 border-gray-300 focus:border-black focus:outline-none text-lg bg-transparent transition-colors"
            />
          </div>

          <div>
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              className="w-full px-0 py-4 border-0 border-b-2 border-gray-300 focus:border-black focus:outline-none text-lg bg-transparent transition-colors"
            />
          </div>

          <div>
            <select
              name="service"
              value={formData.service}
              onChange={(e) => setFormData({ ...formData, service: e.target.value })}
              required
              className="w-full px-0 py-4 border-0 border-b-2 border-gray-300 focus:border-black focus:outline-none text-lg bg-transparent transition-colors cursor-pointer"
            >
              <option value="" disabled>Service Inquiry</option>
              <option value="Yacht Sales">Yacht Sales</option>
              <option value="Yacht Charter">Yacht Charter</option>
              <option value="New Build Management">New Build Management</option>
              <option value="Refit Management">Refit Management</option>
              <option value="Crew Placement">Crew Placement</option>
              <option value="Yacht Financing">Yacht Financing</option>
              <option value="General Inquiry">General Inquiry</option>
            </select>
          </div>

          <div>
            <textarea
              name="message"
              placeholder="Comments or Specific Request"
              value={formData.message}
              onChange={(e) => setFormData({ ...formData, message: e.target.value })}
              required
              maxLength={500}
              rows={4}
              className="w-full px-0 py-4 border-0 border-b-2 border-gray-300 focus:border-black focus:outline-none text-lg bg-transparent resize-none transition-colors"
            />
            <p className="text-sm text-gray-500 mt-2">{formData.message.length}/500 characters</p>
          </div>

          {submitStatus === 'success' && (
            <div className="p-4 bg-gray-100 text-black text-center">
              Thank you for your inquiry. We will be in touch shortly.
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="p-4 bg-gray-100 text-black text-center">
              There was an error submitting your message. Please try again.
            </div>
          )}

          <div className="text-center pt-8">
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-12 py-4 bg-black text-white text-sm tracking-widest hover:bg-gray-800 transition-colors disabled:opacity-50 whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
